<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>

			<el-form-item label="状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" :label="1">启用</el-radio>
				<el-radio v-model="inputmodel.status" :label="0">禁用</el-radio>
			</el-form-item>
			<el-form-item label="公众号消息推送" prop="ismsg"><br>
				<el-switch v-model="inputmodel.ismsg" active-text="开启" inactive-text="关闭" active-color="#13ce66"
					inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="SwitchStatus">
				</el-switch>
			</el-form-item>
		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		house_list,
		administrator_edit,
		administrator_set_ismsg
	} from "@/api/api.js"
	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '账号',
					model: 'account'
				}, {
					name: '姓名',
					model: 'name'
				}, {
					name: '电话',
					model: 'phone'
				}, {
					name: '邮箱',
					model: 'email'
				}],
				inputmodel: {
					account: '',
					name: '',
					phone: '',
					email: '',
					status: '1',
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
				},
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							this.inputmodel.status = String(this.inputmodel.status)
							administrator_edit(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			SwitchStatus(value) {
				console.log('SwitchStatus:', value);

				administrator_set_ismsg({
					aid: this.item.id,
					ismsg: value == '1' ? '1' : '0'
				}).then(res => {
					this.Messages(res)
					if (res.status == 200) {
						this.$emit('changedia', false)
						this.$parent.$parent.$parent.contractlistcontractlist();
					} else {
						this.inputmodel.ismsg = !value
					}
				})
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				console.log('Selected room number:', value);
				// 你可以在这里根据 value 查找对应的 item，例如：
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			house_list().then(res => {
				const _res = res.data.list
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.sex == '男') {
				this.inputmodel.sex = '1'
				console.log(this.inputmodel.sex);
			} else {
				this.inputmodel.sex = '2'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.sex == '男') {
					this.inputmodel.sex = '1'
					console.log(this.inputmodel.sex);
				} else {
					this.inputmodel.sex = '2'
				}

			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>